/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */


import 'swiper/css';
import 'swiper/css/pagination';
import './src/perf/newrelic-bandwidth-beacon';

import {BrowserAgent} from '@newrelic/browser-agent/loaders/browser-agent'
import {GatsbyBrowser} from 'gatsby';

import {WrapRootElement} from './src/commons/wrapRootElement';

const applicationID = process.env.NEWRELIC_APPLICATION_ID || '';
const licenseKey = process.env.NEWRELIC_LICENSE_KEY || '';
const accountID = process.env.NEWRELIC_ACCOUNT_ID || '';

const options = {
  init: {
    distributed_tracing: {enabled: false},
    privacy: {cookies_enabled: false},
    ajax: {enabled: false},
    spa: {enabled: false},
    page_view_timing: {enabled: false},
    session_trace: {enabled: false},
    metric: {enabled: false}
  },
  loader_config: {
    accountID: accountID,
    trustKey: accountID,
    agentID: applicationID,
    licenseKey: licenseKey,
    applicationID: applicationID
  },
  info: {
    beacon: "bam.eu01.nr-data.net",
    errorBeacon: "bam.eu01.nr-data.net",
    licenseKey: licenseKey,
    applicationID: applicationID,
    sa: 1
  },
};
const enableNewRelic = process.env.NODE_ENV === 'production' && licenseKey && applicationID && accountID;
if (enableNewRelic) {
  new BrowserAgent(options);
}

export const wrapRootElement = WrapRootElement;

// persist between calls to shouldUpdateScroll
let previousHash: string | undefined = undefined;
let previousPathname: string | undefined = undefined;

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = (
  {
    pathname,
    routerProps: {location},
    getSavedScrollPosition,
  }) => {

  const isSpecialist = /\/spezialisten\/(\W+|\w+)*/.test(pathname);
  const transitionDelay = isSpecialist ? 1000 : 25;
  let currentPosition = getSavedScrollPosition(location)

  // If there is a hash in the URL, do not override the browser's default behavior
  // Without this there has been cases were on first click the scroll went to the top instead of the anchor
  const hash = (location && location.hash) ? location.hash.replace('#', '') : undefined;
  if (hash) {
    setTimeout(() => {
      const element = document.getElementById(hash);
      if (element) {
        const rect = element.getBoundingClientRect();
        const isInViewport =
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth);

        // Only scroll to the element if it is not already in the viewport
        if (!isInViewport) {
          element.scrollIntoView();
        }
        // Focus the element to make sure screen readers are aware of the change
        element.focus();
      }
    }, transitionDelay);
    previousHash = hash;
    previousPathname = pathname;
    return false;
  }

  // If there is no hash but there was a hash in the previous navigation and the pathname is the same
  // we assume the user navigated from a hash to the same page without a hash and want to scroll to the top
  // This is to handle the case were a user navigates from /page#section to /page and expects to be at the top of the page
  if (!hash && previousHash && previousPathname === pathname) {
    currentPosition = [0, 0];
  }

  // Manually control scroll restoration to avoid conflicts with browser behavior
  // This is for certain cases were you can navigate to a new page but stay on the same scroll position
  window.history.scrollRestoration = "manual"
  setTimeout(() => {
    window.scrollTo(...(isSpecialist ? [0, 0] : (currentPosition || [0, 0])));
    if (isSpecialist) {
      document.querySelectorAll<HTMLAnchorElement>('#header-logo')[0].focus();
    }
  }, transitionDelay);

  previousHash = undefined;
  previousPathname = pathname;
  return false;
};
